<template>
  <div>
    <Navigation />
    <div class="not-found-container">
      <div class="not-found-content glass">
        <div class="content-body">
          <div class="illustration">
            <img src="/img/404-robot.png" alt="Page not found illustration" />
          </div>
          <div class="text-block">
            <h1 class="error-title">Page Not Found</h1>
            <p class="error-description">
              You’ve stepped off the map—no listings, no chatter, just empty space. Let’s get you back where the action is.
            </p>
            <div class="error-actions">
              <router-link to="/" class="btn btn-primary">
                Go to Dashboard
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterSection />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import Navigation from './Navigation.vue';
import FooterSection from './footer.vue';

const router = useRouter();

const goBack = () => {
  router.go(-1);
};
</script>

<style scoped>

.not-found-container {
  min-height: calc(100vh - 160px);
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(1200px at 20% 20%, rgba(255, 255, 255, 0.18), transparent 45%),
    radial-gradient(1000px at 80% 0%, rgba(255, 255, 255, 0.12), transparent 45%),
    linear-gradient(135deg, #6f7cf3 0%, #8b5cf6 50%, #4a6cf7 100%);
  padding: 60px 20px;
}

.not-found-content {
  text-align: center;
  background: rgba(255, 255, 255, 0.92);
  padding: 64px 48px;
  border-radius: 18px;
  box-shadow: 0 30px 80px rgba(58, 67, 116, 0.25);
  max-width: 760px;
  width: 100%;
  backdrop-filter: blur(8px);
}

.glass {
  border: 1px solid rgba(255, 255, 255, 0.28);
}


.content-body {
  position: relative;
}


.error-code {
  font-size: 120px;
  font-weight: 800;
  color: #5a6ff3;
  margin: 0;
  line-height: 1;
}


.error-title {
  font-size: 36px;
  font-weight: 800;
  color: #1f2345;
  margin: 16px 0 12px 0;
  font-family: "Inter", sans-serif;
}


.error-description {
  font-size: 16px;
  color: #4b4f68;
  margin: 0 auto 32px auto;
  line-height: 1.7;
  font-family: "Inter", sans-serif;
  max-width: 540px;
}

.error-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}


.btn {
  padding: 14px 30px;
  font-size: 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  font-weight: 700;
  transition: all 0.25s ease;
  font-family: "Inter", sans-serif;
  width: 320px;
  max-width: 100%;
}

.btn-primary {
  background: linear-gradient(120deg, #5a6ff3 0%, #7b5cf5 50%, #4d8dff 100%);
  color: white;
  box-shadow: 0 12px 30px rgba(90, 111, 243, 0.35);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 36px rgba(90, 111, 243, 0.45);
}

.btn-secondary {
  background: #ffffff;
  color: #1f2345;
  border: 2px solid #5a6ff3;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.btn-secondary:hover {
  background: #f6f8ff;
  border-color: #7b5cf5;
}

.illustration {
  display: flex;
  justify-content: center;
  margin-bottom: 0;
}

.illustration img {
  max-width: 440px;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 20px 44px rgba(74, 108, 247, 0.32));
}

.text-block {
  position: relative;
  margin: -50px auto 0 auto;
  padding: 32px 24px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 48px rgba(58, 67, 116, 0.18);
  max-width: 640px;
}

@media (max-width: 768px) {
  .not-found-container {
    min-height: calc(100vh - 160px);
    padding: 20px 16px;
  }

  .not-found-content {
    padding: 40px 20px;
  }

  .error-code {
    font-size: 80px;
  }

  .error-title {
    font-size: 24px;
  }

  .error-description {
    font-size: 14px;
  }

  .illustration img {
    max-width: 300px;
  }

  .text-block {
    margin-top: -30px;
    padding: 24px 18px;
  }

  .error-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}
</style>
